import { FormProvider, useForm } from "react-hook-form";
import { DaysAvailability } from "../../components/settings/daysAvaibility";
import { useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { getSchedule, setWeekSchedule } from "../../store/appointment/appointmentActions";
import { errorToast, getDeviceTimeZone, successToast } from "../../utils";
import { RangeEventSelected } from "../calendar/rangeEventSelected";
import { RangeEventBlocked } from "./availability/rangeEventBlocked";

const AvailabilitySettings = () => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", ]
    const [isOpen, setIsOpen] = useState(false)
    const [events, setEvents] = useState(false)
    const dispatch = useDispatch();
    const methods = useForm();
    const [isReschedule, setIsReschedule] = useState(false);
    const [isCancel, setIsCancel] = useState(false);
    const [isBlock, setIsBlock] = useState(false);

    useEffect(() => {
        dispatch(getSchedule())
        .unwrap()
        .then(daysResponse => {
            methods.reset({
                days: daysResponse.days.map(singleDay => {
                    return {
                        ...singleDay,
                        name: days[singleDay.day]
                    }
                })
            })
        })
    }, [])

    const closeConflictPanel = () => {
        setIsOpen(false);
        setIsBlock(false);
        setIsCancel(false);
        setIsReschedule(false);
    };

    const onSubmit = async (data) => {
        let payload = { days: data.days };

        if (data.isCancel == "1" && isCancel) {
            payload = {
                days: data.days,
                appointments: {
                    reason: data.reason.label,
                    action: "cancel",
                    events: events.filter((v) => v.role !== "student").map((v) => v._id),
                },
            };
        } else if (data.isReschedule == "1" && isReschedule) {
            payload = {
                days: data.days,
                appointments: {
                    action: "reschedule",
                    timezone: getDeviceTimeZone(),
                    events: data.reschedule.map((v) => {
                        return ({ _id: v._id, time: v.time, message: v.message, reason: v.reason });
                    }),
                },
            };
        } else if (isBlock) {
            payload = {
                days: data.days,
                appointments: {
                    action: "block",
                    events: events.map((v) => v._id),
                },
            };
        }

        dispatch(setWeekSchedule(payload))
        .unwrap()
        .then(v => {
            if(v?.existAppointments){
                setEvents(v.list)
                errorToast("Please check following appointments")
                setIsOpen(true)
            }else{
                setIsOpen(false)
                successToast("Modification applied successfully")
            }
        })
    };

    return (
        <div className="w-full 2xl:w-5/6 mx-auto">
            <form onSubmit={methods.handleSubmit(onSubmit)} disabled={isOpen} className="bg-white relative p-8 rounded-2xl flex flex-col justify-center" >
                <FormProvider {...methods}>
                    
                    <div className="flex flex-col lg:flex-row gap-6">
                        <div className={`relative min-w-0 overflow-visible ${isOpen ? "w-full lg:w-1/2" : "w-full"}`}>
                            <DaysAvailability widthClass="w-full" />
                            {isOpen ? (
                                <div
                                    className="absolute inset-0 z-10 rounded-lg bg-white/80 backdrop-blur-[2px] pointer-events-auto"
                                    aria-hidden="true"
                                />
                            ) : null}
                        </div>
                        {isOpen ? (
                            <div className="w-full lg:w-1/2 shrink-0">
                                <RangeEventBlocked
                                    setIsOpen={closeConflictPanel}
                                    events={events}
                                    isReschedule={isReschedule}
                                    setIsReschedule={setIsReschedule}
                                    isCancel={isCancel}
                                    setIsCancel={setIsCancel}
                                    isBlock={isBlock}
                                    setIsBlock={setIsBlock}
                                />
                            </div>
                        ) : null}
                    </div>
                </FormProvider>
              
                
                <input
                    className={`self-end rounded p-2 mt-5 text-white ${
                        isOpen && !isCancel && !isReschedule && !isBlock
                            ? "bg-nt-blue/50 cursor-not-allowed"
                            : "bg-nt-blue cursor-pointer"
                    }`}
                    type="submit"
                    value="Submit"
                    disabled={isOpen && !isCancel && !isReschedule && !isBlock}
                />
            </form>
        </div>

    )
}

export { AvailabilitySettings }